export const fetchWithAuth = async (url, options = {}, logout) => {
  const token = localStorage.getItem('access_token');

  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    // Token nieważny - wyloguj użytkownika
    if (logout) {
      logout(); // Wywołaj funkcję logout z AuthContext
    } else {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login'; // Przekierowanie na stronę logowania
    }
  }

  return response;
};